import React, { useEffect, useState } from 'react';
import axios from 'axios';
import packageInfo from '../../package.json';

interface VersionDisplayProps {
  className?: string;
}

const VersionDisplay: React.FC<VersionDisplayProps> = ({ className }) => {
  const [backendVersion, setBackendVersion] = useState<string>('');
  const frontendVersion = packageInfo.version;

  useEffect(() => {
    const fetchBackendVersion = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_HTTP_API_URL}/version`);
        if (response.data && response.data.version) {
          setBackendVersion(response.data.version);
        }
      } catch (error) {
        console.error('Error fetching backend version:', error);
        setBackendVersion('unknown');
      }
    };

    fetchBackendVersion();
  }, []);

  return (
    <div className={`version-display ${className || ''}`} style={{ 
      position: 'fixed', 
      bottom: '5px', 
      right: '10px', 
      fontSize: '12px',
      color: '#666',
      fontFamily: 'monospace'
    }}>
      v{frontendVersion} / {backendVersion || '...'}
    </div>
  );
};

export default VersionDisplay;